// removed by extract-text-webpack-plugin
module.exports = {"container":"PriceIndicator-container-ce3e428d","valuationLogo":"PriceIndicator-valuationLogo-4f64f00f","priceRating":"PriceIndicator-priceRating-70cc6a66","priceRatingData":"PriceIndicator-priceRatingData-ae33033a","priceRatingIndicator":"PriceIndicator-priceRatingIndicator-fd15fb29"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/PriceIndicator.scss
// module id = 848
// module chunks = 0